module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Shield-check-df1c964f5c92230e3e6934cd69ace007.svg";